module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"MenuHorizontal":{"heading":"Kategorie"}}}')
  delete Component.options._Ctor
}
